import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import useDialog from '../../../../web-app-components/hooks/useDialog';
import ButtonSlim from '../../../../web-app-components/components/ButtonSlim';
import { Formik } from 'formik';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import objectsClient from '../../../../clients/objects';
import objectsSuggestedClient from '../../../../clients/objects-suggested';

import { toForm, fromForm } from '../../utils/formData';
import prepareFiles from '../../utils/prepareFiles';

import Form from '../../components/Form';

import ConfirmRemoveDialog from './components/ConfirmRemoveDialog';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  title: {
    flex: 1,
  },
}));

const fieldIsEmpty = (value) => {
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }
  if(typeof value === 'object'){   
    return value === null
  }
  return typeof value !== 'number';
};


const SuggestedObject = ({ id }) => {
  const classes = useStyles();

  const history = useHistory();
  const { path } = useRouteMatch();

  const { enqueueSnackbar } = useSnackbar();

  const confirmRemoveDialog = useDialog();

  const [data, setData] = useState();
  const [object, setObject] = useState();

  useEffect(() => {
    (async () => {
      try {
        const response = await objectsSuggestedClient.findOne(id);
        setData(response);
        if(response?.object){
          setObject(await objectsClient.findOne(response.object.id))
        }
      } catch (error) {
        enqueueSnackbar(
          'Nepavyko gauti objekto. Bandykite atidaryti iš naujo.',
          { variant: 'error' }
        );
      }
    })();
  }, [id, enqueueSnackbar]);

  const handleRemoveClick = async () => confirmRemoveDialog.setOpen(true);

  const handleRemoveConfirm = async () => {
    try {
      await objectsSuggestedClient.remove(id);
      enqueueSnackbar('Pasiūlymas pašalintas', { variant: 'success' });
      history.push(`${path.replace('/:id', '')}`);
    } catch (error) {
      enqueueSnackbar('Nepavyko pašalinti pasiūlymo. Bandykite dar kartą.', {
        variant: 'error',
      });
    }
  };

  const handleSubmit = async (values) => {
    try {     
      let newValues = Object.entries(values).reduce((obj, [name, value]) => {       
        if (!fieldIsEmpty(value)) {
          obj[name] = value;
        }
        return obj;
      }, {});

      if(Object.keys(newValues).length === 0){
        return  enqueueSnackbar('Nėra duomenų atnaujinimui', {
          variant: 'error',
        }); 
      }

      if(Array.isArray(newValues.Pictures)) newValues.Pictures = await prepareFiles(newValues.Pictures);
      if(Array.isArray(newValues.AudioRecordings)) newValues.Pictures = await prepareFiles(newValues.AudioRecordings);

      const newData = fromForm(newValues)

      console.log(newData);
      

      if(!data?.object){
        await objectsClient.create(newData);
        enqueueSnackbar('Naujas objektas sukurtas', { variant: 'success' });
      } else {
        const updateData = Object.entries(newData).reduce((obj, [name, value]) => {           
          if(!fieldIsEmpty(value)){
            if(Array.isArray(obj[name]) && Array.isArray(value)){
              obj[name] = [...new Set([...obj[name], ...value])];
            } else {
              obj[name] = value;
            }
          }
          return obj;
        }, fromForm(toForm(object)));      
      
        await objectsClient.update(data.object.id, updateData);
        enqueueSnackbar('Esamas objektas atnaujintas', { variant: 'success' });
      }

    } catch (error) {
      console.warn(error)
      enqueueSnackbar('Nepavyko patvirtinti pasiūlymo. Bandykite dar kartą.', {
        variant: 'error',
      }); 
    }

  };
 
  return data ? (
    <div>
      <div className={classes.header}>
        <Typography className={classes.title} variant="h5">
          {data?.object ? <>Esamas Objektas "<a target='_blank' href={`/objects/${data?.object?.id}`} rel="noreferrer">{data?.object?.Title}</a>"</> : `Naujas Objektas "${data.Title}"`}
        </Typography>
        <ButtonSlim onClick={handleRemoveClick}>Pašalinti pasiūlymą</ButtonSlim>
      </div>
      <Formik
        initialValues={toForm(data)}
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => <Form {...props} suggested />}
      </Formik>
      <ConfirmRemoveDialog
        {...confirmRemoveDialog}
        onConfirm={handleRemoveConfirm}
      />
    </div>
  ) : (
    <CircularProgress />
  );
};

SuggestedObject.propTypes = {
  id: PropTypes.string.isRequired,
};

export default SuggestedObject;
